module.exports = __webpack_public_path__ + "static/media/yopen-forgotPassword.2a450a28.svg";